// C:\xampp\htdocs\sait\client\src\components\MobileBottomNav.js

import React, { useContext, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../../../../index";
import {
    ADD_ROUTE,
    FAVOURITES_ROUTE,
    MAIN_ROUTE,
    PROFILE_ROUTE,
    SHOP_ROUTE,
} from "../../../../utils/consts";

import RegistrationForm from "../../../modals/UserForms/RegistrationForm/RegistrationForm";

import profilePlaceholder from "../../../../Assets/profile.svg";
import { ReactComponent as HomeIcon } from "../../../../Assets/BottomMenu/Home.svg";
import { ReactComponent as ApartmentsIcon } from "../../../../Assets/BottomMenu/Appartments.svg";
import { ReactComponent as ChatIcon } from "../../../../Assets/BottomMenu/chatIconGray.svg";
import { ReactComponent as HeartIcon } from "../../../../Assets/hearts/heart-gray-1-1.svg";

import {
    getMessagesTargetRoute,
    isMessagesRoute,
    formatMessagesBadge
} from "../../../../utils/chat/messagesNavigation";

import styles from "./MobileBottomNav.module.css";
import { reachGoal } from "../../../../utils/metrika/metrika";

const MobileBottomNav = observer(() => {
    const { user, messages } = useContext(Context);
    const history = useHistory();
    const location = useLocation();

    const [showRegistrationModal, setShowRegistrationModal] = useState(false);

    const totalUnreadCount = messages.totalUnreadCount;
    const isMainPage = location.pathname === MAIN_ROUTE;

    const handleChatClick = () => {
        history.push(getMessagesTargetRoute());
    };

    const getProfileImageUrl = () => {
        if (!user.UserData || !user.UserData.id) return profilePlaceholder;

        const userId = user.UserData.id;
        const userImg = user.UserData.img;

        if (userImg === "EMPTY" || !userImg) return profilePlaceholder;

        if (typeof userImg === "string") {
            const constructedPath = `users/user${userId}/${userImg}`;
            return process.env.REACT_APP_API_URL + constructedPath;
        }

        return profilePlaceholder;
    };

    const handleProfileClick = () => {
        if (user.isAuth && user.UserData?.id) {
            history.push(`${PROFILE_ROUTE}/${user.UserData.id}`);
            reachGoal("history.push(`${PROFILE_ROUTE} NAVIGATION`)");
        } else {
            setShowRegistrationModal(true);
        }
    };

    const handleFavouritesClick = () => {
        history.push(FAVOURITES_ROUTE);
        reachGoal("history.push(FAVOURITES_ROUTE) NAVIGATION");
    };

    const navItems = [
        { key: "main", label: "Главная", type: "link", route: MAIN_ROUTE, Icon: HomeIcon },
        { key: "adds", label: "Жилье", type: "link", route: ADD_ROUTE, Icon: ApartmentsIcon },
        { key: "fav", label: "Избранное", type: "button", handler: handleFavouritesClick, Icon: HeartIcon },
        { key: "chat", label: "Сообщения", type: "button", handler: handleChatClick, Icon: ChatIcon },
        { key: "profile", label: "Профиль", type: "button", handler: handleProfileClick, isProfileImage: true },
    ];

    const isItemActive = (item) => {
        if (item.type === "link") {
            if (item.route === MAIN_ROUTE) return location.pathname === MAIN_ROUTE;

            if (item.label === "Жилье") {
                return (
                    location.pathname.startsWith(item.route) ||
                    location.pathname === SHOP_ROUTE ||
                    location.pathname.startsWith('/map_search')
                );
            }

            return location.pathname.startsWith(item.route);
        }

        // button
        if (item.key === "chat") return isMessagesRoute(location.pathname);

        if (item.key === "profile") {
            return (
                user.isAuth &&
                location.pathname.startsWith(PROFILE_ROUTE) &&
                user.UserData?.id &&
                location.pathname.includes(`${PROFILE_ROUTE}/${user.UserData.id}`)
            );
        }

        if (item.key === "fav") return location.pathname.startsWith(FAVOURITES_ROUTE);

        return false;
    };

    const renderIcon = (item) => {
        if (item.isProfileImage) {
            const src = getProfileImageUrl();
            return (
                <img
                    src={src}
                    alt={item.label}
                    className={`${styles.mobileBottomNavIcon} ${styles.mobileBottomNavIconProfile}`}
                />
            );
        }

        if (item.Icon) {
            const IconComp = item.Icon;
            return <IconComp className={styles.mobileBottomNavIcon} aria-hidden="true" />;
        }

        return null;
    };

    const renderBadge = (item) => {
        if (item.key !== "chat") return null;
        if (!totalUnreadCount || totalUnreadCount <= 0) return null;

        return <div className={styles.badge}>{formatMessagesBadge(totalUnreadCount)}</div>;
    };

    return (
        <>
            <nav
                className={[
                    styles.mobileBottomNav,
                    styles.mobileBottomNavHideOnDesktop,
                    isMainPage ? styles.mobileBottomNavMain : "",
                ].join(" ")}
            >
                {navItems.map((item) => {
                    const active = isItemActive(item);
                    const itemClassName = `${styles.mobileBottomNavItem} ${
                        active ? styles.mobileBottomNavItemActive : ""
                    }`;

                    const content = (
                        <>
                            <div className={styles.iconWrapper}>
                                {renderIcon(item)}
                                {renderBadge(item)}
                            </div>

                            <span className={styles.mobileBottomNavLabel}>{item.label}</span>
                        </>
                    );

                    if (item.type === "link") {
                        return (
                            <NavLink key={item.key} to={item.route} className={itemClassName}>
                                {content}
                            </NavLink>
                        );
                    }

                    return (
                        <div key={item.key} className={itemClassName} onClick={item.handler}>
                            {content}
                        </div>
                    );
                })}
            </nav>

            <RegistrationForm show={showRegistrationModal} onHide={() => setShowRegistrationModal(false)} />
        </>
    );
});

export default MobileBottomNav;